import React, { useState } from 'react';
import './Services.css';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  // Data for your services
  const servicesData = [
    {
      id: 1,
      title: 'RESIDENTIAL',
      icon: '🏠', 
      shortDesc: 'Tailored interiors for your home that blend comfort with luxury.',
      fullDesc: `Our Residential Design service is dedicated to creating spaces that reflect your personal style while ensuring maximum comfort. We handle everything from the initial concept to the final styling.
      
      Whether it is a single room makeover or a full home renovation, we focus on:
      • Space Planning & Layout Optimization
      • Color Consultation & Mood Boards
      • Custom Furniture Selection
      • Lighting Design
      
      We believe your home should be your sanctuary. Our team works closely with you to understand your lifestyle needs, ensuring that every corner of your home is both beautiful and functional.`,
      image: '/res.png'
    },
    {
      id: 2,
      title: 'COMMERCIAL',
      icon: '🏢',
      shortDesc: 'Inspiring workspaces and retail environments that elevate your brand.',
      fullDesc: `Your physical space is a powerful extension of your brand identity. Our Commercial Interior strategies are designed to boost productivity for employees and create memorable experiences for clients.
      
      We specialize in:
      • Corporate Offices & Coworking Spaces
      • Retail Stores & Boutiques
      • Hospitality (Cafes, Restaurants, Hotels)
      
      We balance aesthetics with ergonomics and durability, ensuring high-traffic areas maintain their allure over time. Let us help you build an environment that tells your brand's story.`,
      image: '/commercial.jpg'
    },
    {
      id: 3,
      title: 'FURNITURE',
      icon: '🛋️',
      shortDesc: 'Bespoke furniture pieces designed specifically for your unique space.',
      fullDesc: `Sometimes, off-the-shelf furniture simply doesn't fit the vision. Our Custom Furniture service provides you with unique, made-to-measure pieces that perfectly complement your interior architecture.
      
      Our process includes:
      • Design Sketches & 3D Renderings
      • Material Selection (Woods, Fabrics, Metals)
      • Coordination with Skilled Artisans
      • Quality Control & Installation
      
      From built-in wardrobes to statement dining tables, we create functional art that serves as the centerpiece of your room.`,
      image: '/fur.png'
    },
    {
      id: 4,
      title: 'CONSULTATION & STYLING',
      icon: '✨',
      shortDesc: 'Expert advice to refresh your space without a full renovation.',
      fullDesc: `Not every project requires tearing down walls. Sometimes, all a space needs is a fresh perspective. Our Consultation & Styling service is perfect for those who need professional guidance to pull a look together.
      
      This service covers:
      • Art Selection & Placement
      • Accessories & Decor Styling
      • Paint & Wallpaper Selection
      • Window Treatments
      
      We help you refine your palette and arrange your existing pieces to breathe new life into your home.`,
      image: 'https://images.pexels.com/photos/667838/pexels-photo-667838.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
    }
  ];

  const handleOpen = (service) => {
    setSelectedService(service);
    document.body.style.overflow = 'hidden'; // Stop background scrolling
  };

  const handleClose = () => {
    setSelectedService(null);
    document.body.style.overflow = 'auto'; // Restore scrolling
  };

  return (
    <section id="services" className="services-section">
      
      {/* --- HEADER --- */}
      <div className="services-header">
        <h2 className="section-title">OUR SERVICES</h2>
        <div className="title-divider-gold"></div>
        <p className="section-subtitle">Comprehensive design solutions for every space.</p>
      </div>

      {/* --- GRID VIEW (Visible when no service is selected) --- */}
      <div className="services-grid">
        {servicesData.map((item) => (
          <div key={item.id} className="service-card" onClick={() => handleOpen(item)}>
            <div className="service-icon">{item.icon}</div>
            <h3 className="service-card-title">{item.title}</h3>
            <p className="service-short-desc">{item.shortDesc}</p>
            <span className="read-more-link">LEARN MORE &rarr;</span>
          </div>
        ))}
      </div>

      {/* --- FULL PAGE OVERLAY (Visible when a service is selected) --- */}
      {selectedService && (
        <div className="service-modal-overlay">
          <div className="service-modal-content">
            
            {/* Close Button */}
            <button className="close-service-btn" onClick={handleClose}>
              &larr; BACK TO SERVICES
            </button>

            {/* Content Layout */}
            <div className="modal-inner-layout">
              <div className="modal-image-wrapper">
                <img src={selectedService.image} alt={selectedService.title} />
              </div>
              
              <div className="modal-text-wrapper">
                <div className="modal-icon-large">{selectedService.icon}</div>
                <h2 className="modal-service-title">{selectedService.title}</h2>
                <div className="modal-divider"></div>
                
                {/* Formatting the text to handle line breaks */}
                <div className="modal-service-desc">
                  {selectedService.fullDesc.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>

                <button className="modal-contact-btn" onClick={() => {
                  handleClose();
                  document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                }}>
                  GET A QUOTE FOR THIS SERVICE
                </button>
              </div>
            </div>

          </div>
        </div>
      )}

    </section>
  );
};

export default Services;